// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ent-settings-step__title[data-v-2aa872ae] {\n  margin-bottom: 20px;\n  font-weight: bold;\n  font-size: 16px;\n}\n.ent-settings-step__content[data-v-2aa872ae] {\n  width: 100%;\n}\n.ent-settings-step__submit-btn[data-v-2aa872ae] {\n  width: 100%;\n  max-width: 200px;\n  margin: 15px auto 0;\n}\n", ""]);
// Exports
module.exports = exports;
